module.exports = __webpack_public_path__ + "media/images/vp/icon.search-28b03dab36ebc8cfd9262605a85eda15.svg";